import axiosInstance from './AxiosInstance';

const CommodityCodeService = {
  fetchCommodityCode: async (page, pageSize, sortBy, order,searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", // Add searchTerm in the query object
    };
    try {
      const response = await axiosInstance.get('/commodityCode', {
        params: queryObj,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Commodity Codes:', error);
      throw error;
    }
  },

  createCommodityCode: async (data) => {
    try {
      const response = await axiosInstance.post('/commodityCode', data);
      console.log("response.data------------", response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating Commodity Code:', error);
      throw error;
    }
  },

  updateCommodityCode: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/commodityCode/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating Commodity Code with ID ${id}:`, error);
      throw error;
    }
  },

  deleteCommodityCode: async (id) => {
    try {
      const response = await axiosInstance.delete(`/commodityCode/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting Commodity Code with ID ${id}:`, error);
      throw error;
    }
  },
};

export default CommodityCodeService;
